import { useState, useEffect } from "react";
import { toast } from "sonner";
import { LegalLayout, LegalSection } from "@/pages/legal/LegalLayout";
import { getConsent, setConsent } from "@/lib/analytics";

export default function Cookies() {
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c) setAnalytics(!!c.analytics);
  }, []);

  const save = (value) => {
    setAnalytics(value);
    setConsent({ analytics: value, date: new Date().toISOString() });
    toast.success("Vos préférences ont été enregistrées.");
  };

  return (
    <LegalLayout title="Gestion des cookies" crumbLabel="Gestion des cookies" path="/gestion-cookies" description="Gérez vos préférences de cookies sur le site FRELONS50.">
      <LegalSection heading="Qu'est-ce qu'un cookie ?">
        <p>Un cookie est un petit fichier déposé sur votre appareil. Sur ce site, seuls des cookies de mesure d'audience peuvent être utilisés, et uniquement avec votre accord.</p>
      </LegalSection>

      <LegalSection heading="Cookies essentiels">
        <p>Nécessaires au bon fonctionnement du site. Ils sont toujours actifs et ne nécessitent pas de consentement.</p>
      </LegalSection>

      <LegalSection heading="Vos préférences">
        <div className="bg-brand-gray rounded-2xl p-5 flex items-center justify-between gap-4">
          <div>
            <p className="font-semibold text-brand-black">Mesure d'audience</p>
            <p className="text-sm text-brand-text">Nous aide à comprendre l'utilisation du site (statistiques anonymisées).</p>
          </div>
          <button
            role="switch"
            aria-checked={analytics}
            data-testid="cookie-toggle-analytics"
            onClick={() => save(!analytics)}
            className={`relative w-14 h-8 rounded-full transition-colors shrink-0 ${analytics ? "bg-brand-gold" : "bg-gray-300"}`}
          >
            <span className={`absolute top-1 left-1 w-6 h-6 rounded-full bg-white transition-transform ${analytics ? "translate-x-6" : ""}`} />
          </button>
        </div>
        <div className="flex gap-3 mt-4">
          <button data-testid="cookies-accept-all" onClick={() => save(true)} className="px-5 py-2.5 rounded-full bg-brand-black text-white font-bold text-sm">Tout accepter</button>
          <button data-testid="cookies-refuse-all" onClick={() => save(false)} className="px-5 py-2.5 rounded-full border-2 border-brand-black text-brand-black font-bold text-sm">Tout refuser</button>
        </div>
      </LegalSection>
    </LegalLayout>
  );
}
